module.exports = __webpack_public_path__ + "img/registerTextIcon.8b426601.png";